import React, { useEffect } from "react";
import { get } from "lodash";
import { PostSubscriptionLinking, CheckSubscriptionLinking } from "../../../api";
import Cookies from "universal-cookie";
import { DeepBI } from "../../../../isomorphic/integrations";
const cookies = new Cookies();

const SubscriptionLinking = () => {
  useEffect(() => {
    global.userPromise.catch(() => ({})).then(user => {
      let uaid = get(user, ["userId"], "");
      let UserType = get(user, ["userType"], "");

      if (UserType === "P") {
        const Gsubscriptionshown = cookies.get("Gsubscriptionshown");
        if (!Gsubscriptionshown) {
          const currentDate = new Date();
          const expirationDate = new Date(currentDate.getTime() + 3 * 24 * 60 * 60 * 1000); // Set to 3 days from now
          CheckSubscriptionLinking(uaid)
            .then(res => {
              if (res && res.success === true) {
                // Function to link the subscription
                const linkSubscription = async ppid => {
                  global.SWG.push(async subscriptions => {
                    try {
                      const result = await subscriptions.linkSubscription({
                        publisherProvidedId: ppid
                      });
                      console.log(result);
                      if (result && result.success === true) {
                        let PPID = result.publisherProvidedId;

                        PostSubscriptionLinking(PPID)
                          .then(res => {
                            console.log("Linking successful", res);
                            if (res.status === 1) {
                              DeepBI.PingSubscriptions(PPID, "success");
                              if ("gtag" in window) {
                                window.gtag("event", "Gsubscription", {
                                  event_category: "success",
                                  event_label: PPID
                                });
                              }
                            } else {
                              DeepBI.PingSubscriptions(PPID, "failure");
                              if ("gtag" in window) {
                                window.gtag("event", "Gsubscription", {
                                  event_category: "failure",
                                  event_label: PPID
                                });
                              }
                            }
                          })
                          .catch(error => {
                            console.error("Error linking subscriptions", error);
                          });
                      }
                    } catch (e) {
                      console.log(e);
                    }
                  });
                };

                // Initialize SWG and set up event listeners
                (global.SWG = global.SWG || []).push(subscriptions => {
                  subscriptions.init("vikatan.com");

                  // Configure the event manager for analytics integration
                  subscriptions.getEventManager().then(manager => {
                    manager.registerEventListener(event => {
                      // Add code here to send the event to your analytics
                      // sendToAnalytics(event);
                      console.log(event);
                    });
                  });
                });
                // Call the linkSubscription function when the component mounts
                linkSubscription(uaid); // Replace 'PPID_VALUE' with your actual value
                cookies.set("Gsubscriptionshown", "true", {
                  path: "/",
                  domain: ".vikatan.com",
                  expires: expirationDate
                });
              }
            })
            .catch(error => {
              console.error("Error linking subscriptions", error);
            });
        }
      }
    });
  }, []);

  return (
    <div>
      {/* Your React component content here */}
      {/* No need for a button to trigger the function */}
    </div>
  );
};

export default SubscriptionLinking;
